// extracted by mini-css-extract-plugin
module.exports = {"fs-16":"styles_fs-16__dxshw"};